import {defineMessages} from 'react-intl';

export default defineMessages({
	productsToReturn: {
		id: 'returnAuthCreateForm.step2.productsToReturn',
		defaultMessage: 'Products to return',
	},
	modifyButtonText: {
		id: 'returnAuthCreateForm.step2.modifyButtonText',
		defaultMessage: 'Modify',
	},
});
